<template>
    <div>
        <h2 v-if="posts.length && view == 'detail_view'" class="absolute">Posts</h2>
        <ul v-if="view == 'detail_view'" class="space-y-12">
            <li v-for="post in posts" :key="post.id">
               <PostPanel :post="post"/>
            </li>
        </ul>
        <div v-else>
            <div v-for="(post, index) in posts" :key="post.id">
                <PostDetailView :post="post" :class="index == 0 ? '' : 'mt-8'"/>
            </div>
        </div>
    </div>
</template>

<script>

import PostPanel from "@app/Shared/Components/PostPanel";
import PostDetailView from "@app/Shared/Components/PostDetailView";

export default {

    props: {
        posts: {
            type: Array,
            required: true
        },
        view: {
            type: String,
            required: true,
            default: 'detail_view'
        },
    },

    filters: {
        dateFormat: date => dayjs(date).format('MMMM D, YYYY'),
        authorList: authors => _.sortBy(authors, ['pivot.position', 'name', 'id']).map(item => item.name).join(', '),
        duration: duration => Math.ceil(duration / 60),
        startCase: _.startCase,
        categoryList(categories) {
            return _.chain(categories)
                .groupBy('parent_id')
                .map(items => {
                    let parentName = items[0].parent.name;
                    let names = items.map(item => item.name).join('; ');

                    return `${parentName} (${names})`
                })
                .value()
                .join('|')
        }
    },

    components: {
        PostPanel,
        PostDetailView,
    },
    
};

</script>
